import React from 'react'
import QRCode from 'qrcode.react'
import { inject } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router'
import route from '../stores/fetchconfig.json'
import { observer } from 'mobx-react'
/*deprecated
const googleURLShortenerAPIKey = "AIzaSyAEQSfnse_TKCnwe65ZtY6DvRWfDcEPDn4"
const GoogleURL = require( 'google-url' ), googleUrl = new GoogleURL({key:googleURLShortenerAPIKey})
*/
const shortUrl = require('node-url-shortener')

@inject('store') @withRouter @observer
class PDFCollectionPupils extends React.Component {
 constructor (props) {
   super(props)
   this.state = {items:[]}
 }

 printIt () {
   if (window.location.pathname.indexOf('pupils') > -1) {
     setTimeout(window.print,80)
   }
 }

 addPrintEventsToWindow () {
   window.onafterprint = () => {
    this.props.history.replace(route.endpoint + '/')
   }
 }

 componentWillMount () {
   this.addPrintEventsToWindow()

   const { store } = this.props
   const ids = store.getParameterByName('ids')

   this.props.store.getItems(ids,response => {
    const items = response.items

    this.setState({items:this.sortItemsByItemType(items)}, () => {
     if (this.props.isReady) this.props.isReady()
     else this.printIt()
    })

    /*
    store.forEach(
     items,
     (item,callback) => {
      shortUrl.short(item.link, (err, shortUrl) => {
       item.link = shortUrl
       callback(item)
      })
     },
     (results) => {
      this.setState({items:this.sortItemsByItemType(results)}, () => {
       if (this.props.isReady) this.props.isReady()
       else this.printIt()
      })
     }
    )*/

   })

 }

 sortItemsByItemType (items) {
   return items.sort( (a,b) => { return a.typeId - b.typeId })
 }

 render () {
  const { classes } = this.props
  const { items } = this.state

  return (
   <div>
   {items.map( (item,index) => {
     const position = index % 2 === 0 ? 'left' : 'right',
           qrCodeSize = 64, indexSize = 50,
           indexPosition = position === 'left' ? { left:10 } : { right:10 },
           qrCodePosition = position === 'left' ? { float:'right' } : { float:'left' },
           textSpacing = position === 'left' ? { marginLeft: indexSize, marginRight: qrCodeSize, textAlign:'right'} : { marginLeft: qrCodeSize, marginRight: indexSize, textAlign:'left'}

     return <div className={classes.container} key={'example-'+index}>

      <div className={classes.indexContainer} style={indexPosition}>
       <div className={classes.index}> {(index+1)} </div>
      </div>

      <div className={classes.qrCodeContainer} style={qrCodePosition}>
       <QRCode value={item.link} size={qrCodeSize} />
      </div>

      <div className={classes.textContainer} style={textSpacing}>
       <div>{item.title}</div>
       <a href={item.link}> {item.link} </a>
       <div className={classes.itemType}>{item.type.name}</div>
      </div>

      <div className={classes.clear}></div>
     </div>
    })
   }
   </div>
  )
 }
}


const styles = theme => ({
 container: {
  'border-bottom':'1px solid #eee',
  position:'relative',
  padding:10
 },
 indexContainer:{
  position:'absolute',
  'padding-top':15
 },
 index:{
  'border-radius':'50%',
  width:50,
  height:50,
  color:'#ddd',
  display:'flex',
  'justify-content':'center',
  'align-items':'center',
  'font-size':24,
  'font-family':'Comic Sans MS, cursive, sans-serif',
  'box-shadow': '5px 10px'
 },
 qrCodeContainer:{
   width:64,
   'padding-bottom':5,
   'padding-top':5
 },
 qrCodeImage:{
   width:'100%'
 },
 textContainer:{
  'margin-left':64,
  'margin-right':50,
  padding:15
 },
 clear:{
  clear:'both'
 },
 itemType:{
   color:'#ddd',
   fontSize:14
 }
})


export default withStyles(styles, { withTheme: true }) (PDFCollectionPupils)



// WEBPACK FOOTER //
// ./src/components/PDFCollectionPupils.js